// SPDX-License-Identifier: AGPL-3.0-or-later

import {Routes} from '@app/app/Routes';
import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import * as ChannelCommands from '@app/features/channel/commands/ChannelCommands';
import {GroupLeaveFailedModal} from '@app/features/guild/components/alerts/GroupLeaveFailedModal';
import SelectedChannel from '@app/features/navigation/state/SelectedChannel';
import * as RouterUtils from '@app/features/navigation/utils/RouterUtils';
import {Logger} from '@app/features/platform/utils/AppLogger';
import {Checkbox} from '@app/features/ui/checkbox/Checkbox';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import * as ToastCommands from '@app/features/ui/commands/ToastCommands';
import {ME} from '@app/vendor/constants/AppConstants';
import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';

const logger = new Logger('useLeaveGroup');
export const useLeaveGroup = () => {
	const {t} = useLingui();
	return useCallback(
		(channelId: string) => {
			ModalCommands.push(
				modal(() => (
					<ConfirmModal
						title={t`Leave Group`}
						description={t`Are you sure you want to leave this group? You will no longer be able to see any messages.`}
						primaryText={t`Leave Group`}
						primaryVariant="danger-primary"
						checkboxContent={<Checkbox>{t`Leave without notifying other members`}</Checkbox>}
						onPrimary={async (checkboxChecked = false) => {
							try {
								await ChannelCommands.remove(channelId, checkboxChecked);
								const selectedChannel = SelectedChannel.selectedChannelIds.get(ME);
								if (selectedChannel === channelId) {
									RouterUtils.transitionTo(Routes.ME);
								}
								ToastCommands.createToast({
									type: 'success',
									children: t`Left group`,
								});
							} catch (error) {
								logger.error('Failed to leave group', error);
								window.setTimeout(() => {
									ModalCommands.push(modal(() => <GroupLeaveFailedModal />));
								}, 0);
							}
						}}
					/>
				)),
			);
		},
		[t],
	);
};
